var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
define('places/places',["require", "exports", "../geo/geo", "../util/http"], function (require, exports, geo_1, http_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.jumpType = exports.addPlace = exports.isBASE = exports.formatPlace3 = exports.formatPlace1 = exports.formatPlace = exports.getNearby = exports.getPlaces = void 0;
    var futurePlaces;
    var nearbyRadius = 30000;
    /**
     * Fetch user-specific places
     */
    function getPlaces(userId) {
        // Cache get or else fetch places
        if (futurePlaces === undefined) {
            // Fetch places from server
            var url = userId ? "/places.json?userid=" + userId : "/places.json";
            futurePlaces = (0, http_1.getJson)(url);
        }
        return futurePlaces;
    }
    exports.getPlaces = getPlaces;
    /**
     * Get places near a coordinate
     */
    function getNearby(ll, userId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                // Filter from getPlaces
                return [2 /*return*/, getPlaces(userId).then(function (places) {
                        return places
                            .filter(function (p) { return (0, geo_1.fastDistance)(ll.lat, ll.lng, p.lat, p.lng) < nearbyRadius; });
                    })];
            });
        });
    }
    exports.getNearby = getNearby;
    /**
     * Format place as country, name
     */
    function formatPlace(place) {
        if (place) {
            return [place.country, place.name]
                .filter(function (_) { return _; })
                .join(", ");
        }
        else {
            return "";
        }
    }
    exports.formatPlace = formatPlace;
    /**
     * Format place as a single name
     */
    function formatPlace1(place) {
        if (place) {
            return [place.name, place.region, place.country].filter(function (_) { return _; })[0] || "";
        }
        else {
            return "";
        }
    }
    exports.formatPlace1 = formatPlace1;
    /**
     * Format place as country, region, name
     */
    function formatPlace3(place) {
        if (place) {
            return [place.country, place.region, place.name]
                .filter(function (_) { return _; })
                .join(", ");
        }
        else {
            return "";
        }
    }
    exports.formatPlace3 = formatPlace3;
    function isBASE(place) {
        return place !== undefined && ["B", "A", "S", "E", "O"].indexOf(place.objectType) >= 0;
    }
    exports.isBASE = isBASE;
    function addPlace(id, p) {
        return __awaiter(this, void 0, void 0, function () {
            var fp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getPlaces(id)];
                    case 1:
                        fp = _a.sent();
                        fp.push(p);
                        return [2 /*return*/, fp];
                }
            });
        });
    }
    exports.addPlace = addPlace;
    function jumpType(place) {
        if (!place) {
            return "";
        }
        else if (place.objectType === "DZ") {
            return "Skydive";
        }
        else if (isBASE(place)) {
            return "BASE";
        }
        else if (place.objectType === "PG") {
            return "PG";
        }
        else {
            return "";
        }
    }
    exports.jumpType = jumpType;
});
//# sourceMappingURL=/assets/javascripts/places/places.js.map;
